import { useState } from "react";
import { Link } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { ZInput } from "@/components/ZInput";
import ZButton from "@/components/ZButton";
import Logo from "@/components/Logo";
import { MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email: email.trim() });
      setSent(true);
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="z-container" style={{ maxWidth: 460 }} data-testid="forgot-password-page">
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <Logo to={null} size={28} />
      </div>

      {sent ? (
        <div className="z-card" style={{ padding: 28, textAlign: "center" }} data-testid="forgot-password-sent">
          <div style={{ color: "var(--z-teal)", display: "flex", justifyContent: "center", marginBottom: 12 }}>
            <MailCheck size={40} />
          </div>
          <h1 className="z-page-title" style={{ fontSize: 22 }}>Vérifiez vos e-mails</h1>
          <p className="z-page-sub">
            Si un compte est associé à <strong>{email}</strong>, vous recevrez un lien
            pour réinitialiser votre mot de passe (valable 30 minutes).
          </p>
          <Link to="/login" className="z-btn z-btn-outline" style={{ marginTop: 8 }} data-testid="forgot-back-login">
            Retour à la connexion
          </Link>
        </div>
      ) : (
        <>
          <h1 className="z-page-title">Mot de passe oublié</h1>
          <p className="z-page-sub">Entrez votre e-mail, nous vous enverrons un lien de réinitialisation.</p>
          <form onSubmit={submit} className="z-card" style={{ padding: 24 }}>
            <ZInput
              id="email"
              type="email"
              label="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@exemple.com"
              required
              autoComplete="email"
              data-testid="forgot-email"
            />
            {err && <p className="z-error-text" data-testid="forgot-error">{err}</p>}
            <ZButton type="submit" block loading={loading} data-testid="forgot-submit-btn">
              Envoyer le lien
            </ZButton>
            <div style={{ textAlign: "center", marginTop: 16, fontSize: 14, color: "var(--z-muted)" }}>
              <Link to="/login" className="z-link" data-testid="forgot-to-login">Retour à la connexion</Link>
            </div>
          </form>
        </>
      )}
    </div>
  );
}
